<template>
    <div id="app" style="width: 100%;" class="app">
        <dv-border-box-1 :style="{  display: 'flex'}">
            <div class="container">
                <div class="itme" style="margin-left:50px">
                    <div class="box">
                        <dv-border-box-10>
                            <lineChart></lineChart>
                        </dv-border-box-10>
                    </div>
                    <div class="box1" style="margin-top:10px">
                        <dv-border-box-10>
                            <pieChart></pieChart>
                        </dv-border-box-10>
                    </div>
                </div>
                <div class="itme" :style="{width:'48%',height:'100%',margin:'5% 0.3% 0  '}">
                    <div class="top">
                        <instrumentPanel></instrumentPanel>
                    </div>
                    <div class="footer">
                        <dv-border-box-10>
                            <barChart></barChart>
                        </dv-border-box-10>
                    </div>
                </div>
                <div class="itme">
                    <div class="date">
                        <span>{{nowDate}}</span>
                        <span>{{nowWeek}}</span>
                    </div>
                    <dv-border-box-10 class="right">
                        <visitRecord></visitRecord>
                    </dv-border-box-10>
                </div>
            </div>
        </dv-border-box-1>
    </div>
</template>
<script>
import lineChart from "@/components/dataBoard/lineChart";
import pieChart from "@/components/dataBoard/pieChart";
import instrumentPanel from "@/components/dataBoard/instrumentPanel";
import barChart from "@/components/dataBoard/barChart";
import visitRecord from "@/components/dataBoard/visitRecord";
export default {
    components: {
        lineChart,
        pieChart,
        instrumentPanel,
        barChart,
        visitRecord,
    },
    data() {
        return {
            nowWeek: '',
            nowDate: '',
        };
    },
    mounted() {
        this.setNowTimes()
    },
    methods: {
        setNowTimes() {
            //获取当前时间
            let myDate = new Date()
            let wk = myDate.getDay()
            let yy = String(myDate.getFullYear())
            let mm = myDate.getMonth() + 1
            let dd = String(myDate.getDate() < 10 ? '0' + myDate.getDate() : myDate.getDate())
            let weeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
            let week = weeks[wk]
            this.nowDate = yy + '年' + mm + '月' + dd + '日'
            this.nowWeek = week
        }
    },
};
</script>
<style lang='scss' scoped>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    background-image: url(../assets/img/shujukanban.png);
    background-size: cover;
    width: 100%;
    height: 100%;
}

.itme {
    //margin-top: 75px;
    float: left;
    width: 23.3%;
    height: 100%;
    padding: 0px 0px 0px 0px;
    margin: 45px 0px 10px 0px;
    .top {
        width: 100%;
        height: 50%;
    }
    .footer {
        width: 100%;
        height: 31%;
        // background-color: skyblue;
        .dv-border-box-10 {
            width: 100%;
            height: 100%;
        }
    }
    .right {
        width: 100%;
        height: 83%;
    }
    .date {
        color: #fff;
        font-size: 20px;
        font-weight: bold;
        height: 3%;
    }
}
.box {
    width: 100%;
    height: 40%;
}
.box1 {
    width: 100%;
    height: 46%;
}
.container {
    height: 100%;
    flex-direction: row;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: flex-start;
}
</style>


// WEBPACK FOOTER //
// src/views/homeData.vue